<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb001"><a id="page_xiv"></a><a href="#/xhtml/contents#abb-001">Abbreviations</a></p>
<table class="abbre">
<tbody><tr><td>AB</td><td>Anchor Bible</td></tr>
<tr><td><i>ABD</i></td><td><i>Anchor Bible Dictionary</i> (1992)</td></tr>
<tr><td>AIL</td><td>Ancient Israel and Its Literature</td></tr>
<tr><td>AnBib</td><td>Analecta Biblica</td></tr>
<tr><td>ANEM</td><td>Ancient Near East Monographs</td></tr>
<tr><td><i>ANET</i></td><td><i>Ancient Near Eastern Texts Relating to the Old Testament</i>, 3rd ed. (1969)</td></tr>
<tr><td>AOAT</td><td>Alter Orient und Altes Testament</td></tr>
<tr><td>AOTC</td><td>Abingdon Old Testament Commentaries</td></tr>
<tr><td><i>BA</i></td><td><i>Biblical Archaeologist</i></td></tr>
<tr><td><i>BASOR</i></td><td><i>Bulletin of the American Schools of Oriental Research</i></td></tr>
<tr><td><i>BBR</i></td><td><i>Bulletin for Biblical Research</i></td></tr>
<tr><td>BETL</td><td>Bibliotheca Ephemeridum Theologicarum Lovaniensium</td></tr>
<tr><td><i>Bib</i></td><td><i>Biblica</i></td></tr>
<tr><td><i>BibInt</i></td><td><i>Biblical Interpretation</i></td></tr>
<tr><td>BIW</td><td>The Bible in Its World</td></tr>
<tr><td>BJS</td><td>Brown Judaic Studies</td></tr>
<tr><td><i>BO</i></td><td><i>Bibliotheca Orientalis</i></td></tr>
<tr><td>BWANT</td><td>Beiträge zur Wissenschaft vom Alten und Neuen Testament</td></tr>
<tr><td>BZABR</td><td>Beihefte zur Zeitschrift für altorientalische und biblische Rechtsgeschichte</td></tr>
<tr><td>BZAW</td><td>Beihefte zur Zeitschrift für die alttestamentlische Wissenschaft</td></tr>
<tr><td>CahRB</td><td>Cahiers de la Revue biblique</td></tr>
<tr><td><i>CANE</i></td><td><i>Civilizations of the Ancient Near East</i> (1995)</td></tr>
<tr><td>CBET</td><td>Contributions to Biblical Exegesis and Theology</td></tr>
<tr><td><a id="page_xv"><i>CBQ</i></a></td><td><i>Catholic Biblical Quarterly</i></td></tr>
<tr><td>CBQMS</td><td>Catholic Biblical Quarterly Monograph Series</td></tr>
<tr><td><i>ChrCent</i></td><td><i>Christian Century</i></td></tr>
<tr><td>ConBOT</td><td>Coniectanea Biblica: Old Testament Series</td></tr>
<tr><td><i>COS</i></td><td><i>The Context of Scripture</i> (2003)</td></tr>
<tr><td><i>CTJ</i></td><td><i>Calvin Theological Journal</i></td></tr>
<tr><td><i>CV</i></td><td><i>Communio Viatorum</i></td></tr>
<tr><td><i>DSD</i></td><td><i>Dead Sea Discoveries</i></td></tr>
<tr><td>ECC</td><td>Eerdmans Critical Commentary</td></tr>
<tr><td><i>EncJud</i></td><td><i>Encyclopaedia Judaica</i> (1972)</td></tr>
<tr><td><i>ExAud</i></td><td><i>Ex Auditu</i></td></tr>
<tr><td><i>ExpTim</i></td><td><i>Expository Times</i></td></tr>
<tr><td>FAT</td><td>Forschungen zum Alten Testament</td></tr>
<tr><td>FAT/2</td><td>Forschungen zum Alten Testament (2nd ser.)</td></tr>
<tr><td>FRLANT</td><td>Forschungen zur Religion und Literatur des Alten und Neuen Testaments</td></tr>
<tr><td>GBS</td><td>Guides to Biblical Scholarship</td></tr>
<tr><td><i>HAR</i></td><td><i>Hebrew Annual Review</i></td></tr>
<tr><td>HCOT</td><td>Historical Commentary on the Old Testament</td></tr>
<tr><td>HdO</td><td>Handbuch der Orientalistik</td></tr>
<tr><td>HThKAT</td><td>Herders Theologischer Kommentar zum Alten Testament</td></tr>
<tr><td><i>HTR</i></td><td><i>Harvard Theological Review</i></td></tr>
<tr><td><i>HUCA</i></td><td><i>Hebrew Union College Annual</i></td></tr>
<tr><td><i>HvTSt</i></td><td><i>Hervormde teologiese studies</i></td></tr>
<tr><td><i>IDB</i></td><td><i>The Interpreter’s Dictionary of the Bible</i> (1962)</td></tr>
<tr><td><i>IEJ</i></td><td><i>Israel Exploration Journal</i></td></tr>
<tr><td><i>Int</i></td><td><i>Interpretation</i></td></tr>
<tr><td><i>JAOS</i></td><td><i>Journal of the American Oriental Society</i></td></tr>
<tr><td><i>JBL</i></td><td><i>Journal of Biblical Literature</i></td></tr>
<tr><td>JBS</td><td>Jerusalem Biblical Studies</td></tr>
<tr><td><i>JFSR</i></td><td><i>Journal of Feminist Studies in Religion</i></td></tr>
<tr><td><i>JHebS</i></td><td><i>Journal of Hebrew Scriptures</i></td></tr>
<tr><td><i>JNES</i></td><td><i>Journal of Near Eastern Studies</i></td></tr>
<tr><td><i>JSOT</i></td><td><i>Journal for the Study of the Old Testament</i></td></tr>
<tr><td>JSOTSup</td><td>Journal for the Study of the Old Testament Supplement Series</td></tr>
<tr><td><i>JSQ</i></td><td><i>Jewish Studies Quarterly</i></td></tr>
<tr><td><i>JSS</i></td><td><i>Journal of Semitic Studies</i></td></tr>
<tr><td>LAI</td><td>Library of Ancient Israel</td></tr>
<tr><td>LHBOTS</td><td>The Library of Hebrew Bible/Old Testament Studies</td></tr>
<tr><td><a id="page_xvi">NCB</a></td><td>New Century Bible</td></tr>
<tr><td>NEchtB</td><td>Neue Echter Bibel</td></tr>
<tr><td>NIBCNT</td><td>New International Biblical Commentary on the New Testament</td></tr>
<tr><td>NIBCOT</td><td>New International Biblical Commentary on the Old Testament</td></tr>
<tr><td>NovTSup</td><td>Supplements to Novum Testamentum</td></tr>
<tr><td><i>NTS</i></td><td><i>New Testament Studies</i></td></tr>
<tr><td>OBO</td><td>Orbis Biblicus et Orientalis</td></tr>
<tr><td>OBT</td><td>Overtures to Biblical Theology</td></tr>
<tr><td>OTL</td><td>Old Testament Library</td></tr>
<tr><td><i>PRSt</i></td><td><i>Perspectives in Religious Studies</i></td></tr>
<tr><td>RBS</td><td>Resources for Biblical Study</td></tr>
<tr><td><i>RelS</i></td><td><i>Religious Studies</i></td></tr>
<tr><td><i>RIDA</i></td><td><i>Revue internationale des droits de l’antiquité</i></td></tr>
<tr><td>SAA</td><td>State Archives of Assyria</td></tr>
<tr><td>SANT</td><td>Studien zum Alten und Neuen Testaments</td></tr>
<tr><td>SBL</td><td>Society of Biblical Literature</td></tr>
<tr><td>SBLDS</td><td>Society of Biblical Literature Dissertation Series</td></tr>
<tr><td>SBLMS</td><td>Society of Biblical Literature Monograph Series</td></tr>
<tr><td>SBLStBL</td><td>Society of Biblical Literature Studies in Biblical Literature</td></tr>
<tr><td>SBT</td><td>Studies in Biblical Theology</td></tr>
<tr><td>ScrHier</td><td>Scripta Hierosolymitana</td></tr>
<tr><td>SJLA</td><td>Studies in Judaiasm in Late Antiquity</td></tr>
<tr><td><i>SR</i></td><td><i>Studies in Religion</i></td></tr>
<tr><td><i>StudBib</i></td><td><i>Studia Biblica</i></td></tr>
<tr><td>SymS</td><td>Symposium Series</td></tr>
<tr><td>TAPS</td><td>Transactions of the American Philosophical Society</td></tr>
<tr><td><i>TDOT</i></td><td><i>Theological Dictionary of the Old Testament</i> (1974–).</td></tr>
<tr><td><i>VT</i></td><td><i>Vetus Testamentum</i></td></tr>
<tr><td>VTSup</td><td>Supplements to Vetus Testamentum</td></tr>
<tr><td>WAW</td><td>Writings from the Ancient World</td></tr>
<tr><td>WAWSup</td><td>Writings from the Ancient World Supplement Series</td></tr>
<tr><td>WBC</td><td>Word Biblical Commentary</td></tr>
<tr><td>WMANT</td><td>Wissenschaftliche Monographien zum Alten und Neuen Testament</td></tr>
<tr><td><i>ZABR</i></td><td><i>Zeitschrift für altorientalische und biblische Rechtsgeschichte</i></td></tr>
<tr><td><i>ZAW</i></td><td><i>Zeitschrift für die alttestamentlische Wissenschaft</i></td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?191b9575